import { useState } from "react";
import { Package } from "lucide-react";
import { API } from "@/lib/api";

export const UrunGorsel = ({ id, var: varMi, className = "w-16 h-16", testid }) => {
  const [hata, setHata] = useState(false);
  if (!varMi || hata) return <div data-testid={testid} className={`${className} rounded-lg bg-white/5 flex items-center justify-center shrink-0`}><Package className="w-1/3 h-1/3 text-muted-foreground" /></div>;
  return <img data-testid={testid} src={`${API}/urun-gorsel/${id}`} alt="" loading="lazy" onError={() => setHata(true)} className={`${className} rounded-lg object-cover bg-white shrink-0`} />;
};
